import React from 'react'
import SubresellersContainer from 'containers/panel/reseller/subresellers-container'

const SubresellersPage = () => {
  return (
    <SubresellersContainer/>
  )
}

export default SubresellersPage